<template>
  <s-crud
    title="Sustancias por Mercado"
    :config="config"
    @save="save($event)"
    edit
    add
    remove
    :filter="filter"
    search-input
    ref="crud"
  >
    <template scope="props">
      <v-container style="padding-top:0px;" v-if="props.item != null" class="pb-0">
        <v-row>
          <v-col cols="12" sm="6" class="s-col-form">
            <s-select
              v-model="props.item.AsuID"
              :items="substanceOptions"
              label="Sustancia (Activa) *"
              placeholder="Seleccionar..."
            />
          </v-col>
          <v-col cols="12" sm="6" class="s-col-form">
            <s-select-definition
              v-model="props.item.TypeStatus"
              :def="1754"
              label="Estado Regulatorio *"
            />
          </v-col>
          <v-col cols="12" class="s-col-form">
            <s-textarea
              v-model="props.item.Observation"
              label="Observación"
              placeholder="Observación opcional..."
              :rows="3"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:TypeStatusName="{ row }">
      <v-chip
        style="margin:0px"
        x-small
        :color="row.TypeStatus == 1 ? 'success' : row.TypeStatus == 2 ? 'warning' : 'error'"
      >
        {{ row.TypeStatusName || (row.TypeStatus == 1 ? "Permitido" : row.TypeStatus == 2 ? "Restringido" : "Prohibido") }}
      </v-chip>
    </template>

    <template v-slot:SecStatus="{ row }">
      <v-chip style="margin:0px" x-small :color="row.SecStatus == 1 ? 'success' : 'error'">
        {{ row.SecStatus == 1 ? "Activo" : "Inactivo" }}
      </v-chip>
    </template>
  </s-crud>
</template>

<script>
import _sMarketSubstancesService from "@/services/Technicalassistance/MarketSubstancesService";
import _sSubstancesService from "@/services/Technicalassistance/SubstancesService";

export default {
  name: "MarketSubstances",
  props: {
    MktID: { type: Number, default: 0 },
  },
  data() {
    return {
      substanceOptions: [],
      filter: { MktID: 0 },
    };
  },
  computed: {
    config() {
      return {
        title: "Sustancias por Mercado",
        service: _sMarketSubstancesService,
        model: {
          MksID: "ID",
          MktID: "int",
          AsuID: "int",
          SubstanceDescription: "string",
          TypeStatus: "int",
          TypeStatusName: "string",
          Observation: "string",
          SecStatus: "status",
        },
        headers: [
          { text: "ID", value: "MksID", width: "10%", sortable: false },
          { text: "Sustancia", value: "SubstanceDescription", width: "40%", sortable: false },
          { text: "Estado Regulatorio", value: "TypeStatusName", width: "25%", sortable: false, align: "center" },
          { text: "Estado", value: "SecStatus", width: "15%", sortable: false, align: "center" },
        ],
      };
    },
  },
  watch: {
    MktID() {
      this.Initialize();
    },
  },
  created() {
    this.loadSubstancesCatalog();
    this.Initialize();
  },
  methods: {
    Initialize() {
      this.filter = { MktID: this.MktID };
    },
    loadSubstancesCatalog() {
      const requestID = this.$fun.getUserID();
      _sSubstancesService.list(requestID)
        .then((res) => {
          const list = res.data || [];
          this.substanceOptions = list.map((s) => ({
            text: s.Description || s.DescriptionSubstances || `Sustancia #${s.AsuID}`,
            value: s.AsuID,
          }));
        })
        .catch((err) => {
          console.error("Error al cargar lista de sustancias:", err);
        });
    },
    save(item) {
      if (!this.MktID || this.MktID === 0) {
        this.$fun.alert("Seleccione un mercado primero en la grilla izquierda.", "warning");
        return;
      }
      if (!item.AsuID) {
        this.$fun.alert("Seleccione una sustancia obligatoriamente.", "warning");
        return;
      }
      if (!item.TypeStatus) {
        this.$fun.alert("Seleccione el estado regulatorio de la sustancia.", "warning");
        return;
      }

      item.MktID = this.MktID;
      item.SecStatus = 1;
      item.UsrCreateID = this.$fun.getUserID();
      item.save();
    },
  },
};
</script>
